import { render, staticRenderFns } from "./zhu.vue?vue&type=template&id=efe681b2&scoped=true&"
import script from "./zhu.vue?vue&type=script&lang=js&"
export * from "./zhu.vue?vue&type=script&lang=js&"
import style0 from "./zhu.vue?vue&type=style&index=0&id=efe681b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe681b2",
  null
  
)

export default component.exports